var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import Modal from 'react-bootstrap/Modal';
import Notification from "../../App/components/Notification";
import ArtsApprovalService from "../services/ArtsApprovalService";
import ModalDisapprovalOfArt from "./ModalDisapprovalOfArt";
import DesignerInternalFields from "./DesignerInternalFields";
import useAuth from "../../App/hooks/useAuth";
import { designerRole } from "../../App/helpers/RoleHelper";
import "../styles/ModalApproveOrDisapproveArt.css";
import CloseIcon from '@mui/icons-material/Close';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { handleServiceError } from "../../App/components/ErrorHandler";
import { onEnterOrSpace } from "../../App/utils/accessibility";
import { setClarityTag } from "../../App/utils/clarity";
import { notifyOpenerArtUpdated } from "../../App/utils/windowMessaging";
function ModalApproveOrDisapproveArt(props) {
    var _a, _b, _c;
    var artId = (_a = props.artHistories[0]) === null || _a === void 0 ? void 0 : _a.art_id;
    var userId = (_b = props.artHistories[0]) === null || _b === void 0 ? void 0 : _b.user_id;
    var auth = useAuth().auth;
    var isDesigner = auth.role_id === designerRole;
    var _d = useState(''), ticketArtsCount = _d[0], setTicketArtsCount = _d[1];
    var _e = useState(null), usedTemplate = _e[0], setUsedTemplate = _e[1];
    var _f = useState([]), selectedProductGroupIds = _f[0], setSelectedProductGroupIds = _f[1];
    var _g = useState('main'), step = _g[0], setStep = _g[1];
    useEffect(function () {
        setTicketArtsCount('');
        setUsedTemplate(null);
        setSelectedProductGroupIds([]);
        setStep('main');
    }, [props.artHistories]);
    function handleSendEmailApprovedArt(user_id, art_id) {
        setClarityTag("actionType", "ticket-history-approve-click");
        Notification().Confirm.show("Aprovar arte", "Tem certeza que deseja aprovar a arte?", "Cancelar", "Aprovar", function () {
        }, function () {
            var artsData = { user_id: user_id, art_id: art_id };
            if (isDesigner) {
                if (ticketArtsCount !== '') {
                    artsData.ticket_arts_count = Number(ticketArtsCount);
                }
                ;
                if (usedTemplate !== null) {
                    artsData.used_template = usedTemplate;
                }
                ;
                if (selectedProductGroupIds.length > 0) {
                    artsData.content_supplier_product_group_ids = selectedProductGroupIds;
                }
                ;
            }
            ;
            sendEmailApproved(artsData);
        }, {
            okButtonBackground: "#ccc",
            cancelButtonBackground: "#F44336"
        });
    }
    ;
    function sendEmailApproved(artsData) {
        ArtsApprovalService.sendEmailApproved(artsData)
            .then(function (res) {
            Notification().Block.circle("[data-id=arts-grid]");
            Notification().Notify.success("E-mail de aprovação enviada com sucesso!");
            props.closeArtAssessmentModal();
            notifyOpenerArtUpdated();
            window.location.reload();
        }, function (err) {
            Notification().Block.remove("[data-id=arts-grid]");
            handleServiceError(err);
        });
    }
    ;
    return (_jsxs(_Fragment, { children: [_jsxs(Modal, __assign({ show: props.showArtAssessmentModal, onHide: props.closeArtAssessmentModal, size: "lg", "aria-labelledby": "contained-modal-title-vcenter", centered: true, className: "modal-approve-or-disapprove-art" }, { children: [_jsxs(Modal.Header, { children: [_jsxs("div", __assign({ className: "modal-approve-header-text" }, { children: [_jsx("span", __assign({ className: "modal-approve-header-label" }, { children: "Revis\u00E3o de arte" })), _jsxs("h4", { children: ["Avaliar arte de ", " ", _jsx("strong", { children: (_c = props.artHistories[0]) === null || _c === void 0 ? void 0 : _c.customer_name })] })] })), _jsx(CloseIcon, { id: "btn-modal-approve-art-close-icon", role: "button", tabIndex: 0, "aria-label": "Fechar", onClick: props.closeArtAssessmentModal, onKeyDown: onEnterOrSpace(props.closeArtAssessmentModal) })] }), _jsxs(Modal.Body, { children: [step === 'main' && _jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "modal-approve-info-box" }, { children: [_jsx(InfoOutlinedIcon, {}), _jsx("p", { children: "Ao avaliar certifique-se que visualizou corretamente o arquivo relacionado ao ISP desejado. Ap\u00F3s a confirma\u00E7\u00E3o o ISP receber\u00E1 por e-mail a sua resposta." })] })), _jsxs("div", __assign({ className: "modal-approve-actions" }, { children: [_jsxs("button", __assign({ id: "btn-disapprove-art", className: "btn-disapprove-art", onClick: function () { setClarityTag("actionType", "ticket-history-disapprove-click"); props.callbackOpenModalToDisapproveTheArt(props.artHistories); } }, { children: [_jsx(HighlightOffIcon, { fontSize: "small" }), " Reprovar"] })), _jsxs("button", __assign({ id: "btn-approve-art", className: "btn-approve-art", onClick: function () {
                                                    if (isDesigner) {
                                                        setStep('designer-fields');
                                                    }
                                                    else {
                                                        handleSendEmailApprovedArt(userId, artId);
                                                    }
                                                } }, { children: [_jsx(CheckCircleOutlineIcon, { fontSize: "small" }), " Aprovar"] }))] }))] }), step === 'designer-fields' && _jsxs(_Fragment, { children: [_jsx(DesignerInternalFields, { ticketArtsCount: ticketArtsCount, onChangeTicketArtsCount: setTicketArtsCount, usedTemplate: usedTemplate, onChangeUsedTemplate: setUsedTemplate, selectedProductGroupIds: selectedProductGroupIds, onChangeSelectedProductGroupIds: setSelectedProductGroupIds }), _jsxs("div", __assign({ className: "modal-approve-actions" }, { children: [_jsx("button", __assign({ id: "btn-approve-art-back", className: "btn-disapprove-art", onClick: function () { return setStep('main'); } }, { children: "Voltar" })), _jsxs("button", __assign({ id: "btn-approve-art-confirm", className: "btn-approve-art", onClick: function () { handleSendEmailApprovedArt(userId, artId); } }, { children: [_jsx(CheckCircleOutlineIcon, { fontSize: "small" }), " Confirmar aprova\u00E7\u00E3o"] }))] }))] })] })] })), _jsx(ModalDisapprovalOfArt, { artHistories: props.artHistories, openModalToDisapproveArt: props.openModalToDisapproveArt, closeModalToDisapproveArt: props.closeopenModalToDisapproveArt })] }));
}
export default ModalApproveOrDisapproveArt;
